import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tag-status',
  templateUrl: './tag-status.component.html',
  styleUrl: './tag-status.component.css'
})
export class TagStatusComponent {

  @Input() status!: string;

  getStatus(): string {

    let stt = '';

    switch (this.status) {
      case "IT":
        stt = "Integrado";
        break;
      case "IP":
        stt = "Enviando ao PIMS";
        break;
      case "AP":
        stt = "Aguardando Pesagem";
        break;
      case "IE":
        stt = "Pendente Envio ao ERP";
        break;
      case "ER":
        stt = "Erro";
        break;
      case "GC":
        stt = "Gerando Certificado";
        break;
      case "NI":
        stt = "Pendente integração";
        break;
      case "EP":
        stt = "Em processamento";
        break;
      case "RI":
        stt = "Retornar ID/PIMS";
        break;
      case "AE":
        stt = "Aguardando Emissão";
        break;
      case "ES":
        stt = "Estornado";
        break;
      case "CP":
        stt = "Cancelamento Pendente";
        break;
      case "CA":
        stt = "Cancelado";
        break;
      case "INTEGRADO":
        stt = "Integrado";
        break;
      case "ERRO":
        stt = "Erro";
        break;
      case "NAO_INTEGRADO":
        stt = "Pendente Integração";
        break;
      case "ESTORNADO":
        stt = "Pendente Integração";
        break;
      case "CANCELADO":
        stt = "Pendente Integração";
        break;
      default:
        stt = this.status;
        break;
    }

    return stt;

  }

  getSeverity(): string {
    let stt = '';

    switch (this.status) {
      case "IT":
        stt = "success";
        break;
      case "ER":
        stt = "danger";
        break;

      case "INTEGRADO":
        stt = "success";
        break;
      case "ERRO":
        stt = "danger";
        break;

      default:
        stt = "info";
        break;
    }

    return stt;
  }

}
